<div>
  @if (!naytaVainViitteenneJaLisatiedot) {
    <div>
      <!-- <mat-form-field floatPlaceholder="always">
      <mat-label>{{ 'lasku.laskunro' | translate | async }}</mat-label>
      <input type="text" formControlName="laskunro"  matInput />
      <mat-error *ngIf="fieldErrors.laskunro">{{fieldErrors.laskunro}}</mat-error>
    </mat-form-field> -->
      <mat-form-field style="width: 48%; float: left">
        <mat-label>{{ 'lasku.laskunpvm' | translate | async }}</mat-label>
        <input numberDatePicker aria-readonly="true" type="text" [matDatepicker]="picker3" [formField]="parent.laskunpvm" matInput data-lpignore="true" />
      </mat-form-field>
      <mat-datepicker #picker3></mat-datepicker>
      <mat-form-field style="width: 48%; float: right">
        <mat-label>{{ 'lasku.toimituspvm' | translate | async }}</mat-label>
        <input type="text" numberDatePicker [matDatepicker]="picker" [formField]="parent.toimituspvm" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      </mat-form-field>
      <mat-datepicker #picker></mat-datepicker>
    </div>
    <div style="clear: both; display: block"></div>

    <div class="maksuehto-kentat" [class.piilotettu]="kateislasku">
      <div>
        <mat-form-field style="width: 48%; float: left">
          <mat-label>{{ 'lasku.maksuaikaa' | translate | async }}</mat-label>
          <input type="number" step="1" [formField]="parent.maksuaikaa" matInput data-lpignore="true" />
          <span matSuffix>pv</span>
          @if (14 > maksuaikaaField().value()) {
            <mat-hint>Alle 14 laillinen vain yrityksille</mat-hint>
          }
          @if (onkoVirhe(maksuaikaaField, 'required') && (maksuaikaaField().dirty() || maksuaikaaField().touched())) {
            <mat-error>
              {{ 'lasku.validation.maksuaikaa.required' | translate | async }}
            </mat-error>
          }
          @if (onkoVirhe(maksuaikaaField, 'min') && (maksuaikaaField().dirty() || maksuaikaaField().touched())) {
            <mat-error>
              {{ 'lasku.validation.maksuaikaa.min' | translate | async }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field style="width: 48%; float: right">
          <mat-label>{{ 'lasku.erapaiva' | translate | async }}</mat-label>
          <input type="text" numberDatePicker [matDatepicker]="picker2" [min]="minErapaivaDate()" [formField]="parent.erapaiva" matInput data-lpignore="true" />
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          @if (onkoVirhe(erapaiva, 'min') && (erapaiva().dirty() || erapaiva().touched())) {
            <mat-error>
              {{ 'lasku.validation.erapaiva.required' | translate | async }}
            </mat-error>
          }
          @if (onkoVirhe(erapaiva, 'matDatepickerMin') && (erapaiva().dirty() || erapaiva().touched())) {
            <mat-error>
              {{ 'lasku.validation.erapaiva.matDatepickerMin' | translate | async }}
            </mat-error>
          }
        </mat-form-field>
        <mat-datepicker #picker2></mat-datepicker>
      </div>
    </div>
    <div style="clear: both; display: block"></div>
  }

  <div class="viitteenne-ja-lisatiedot" [class.vierekkain]="naytaVainViitteenneJaLisatiedot" [class.viivastyskorolla]="naytaVainViitteenneJaLisatiedot && naytaViivastuskorko">
    <mat-form-field>
      <mat-label>{{ 'lasku.viitteenne' | translate | async }}</mat-label>
      <input type="text" [formField]="parent.viitteenne" autocomplete="kirjanpitomerkkiarkki" matInput data-lpignore="true" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'lasku.lisatiedot' | translate | async }}</mat-label>
      <textarea type="text" [formField]="parent.lisatiedot" autocomplete="kirjanpitomerkkiarkki" cdkTextareaAutosize matInput data-lpignore="true"></textarea>
    </mat-form-field>

    @if (naytaViivastuskorko) {
      <mat-form-field>
        <mat-label>{{ 'lasku.viivastyskorko' | translate | async }}</mat-label>
        <input decimalNumberField type="text" [formField]="parent.viivastyskorko" matInput data-lpignore="true" />
        <span matSuffix>%</span>
        <!-- <mat-hint *ngIf="14 > viivastyskorkoField?.value">Alle 14 laillinen vain yrityksille</mat-hint> -->
        @if (onkoVirhe(viivastyskorkoField, 'required') && (viivastyskorkoField().dirty() || viivastyskorkoField().touched())) {
          <mat-error>
            {{ 'lasku.validation.viivastyskorko.required' | translate | async }}
          </mat-error>
        }
        @if (onkoVirhe(viivastyskorkoField, 'min') && (viivastyskorkoField().dirty() || viivastyskorkoField().touched())) {
          <mat-error>
            {{ 'lasku.validation.viivastyskorko.min' | translate | async }}
          </mat-error>
        }
      </mat-form-field>
    }
  </div>
</div>
